import {Component, Input, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {NgSelectComponent} from '@ng-select/ng-select';
import {Select} from 'primeng/select';
import {Checkbox} from 'primeng/checkbox';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-employees',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    NgSelectComponent,
    Select,
    Checkbox,
  ],
  template: `
    <div class="form-row">
      <label>{{ Yii.t('app', 'Positions Filter') }}</label>
      <div>
        <ng-select
          style="width: 480px"
          appendTo="body"
          [multiple]="true"
          [addTag]="addTagFn"
          [(ngModel)]="positions"
          (change)="field.positions_filter = positions.join(',')"
        ></ng-select>
      </div>
    </div>
    <div class="form-row">
      <label></label>
      <div class="flex-row gap-8px flex-align-center">
        <p-checkbox
          [(ngModel)]="field.autocomplete"
          binary="true"
          />
        <label>{{ Yii.t('app', 'Autocomplete') }}</label>
      </div>
    </div>
    <div class="form-row flex-align-center">
      <label>{{ Yii.t('app', 'Link to employee File') }}</label>
      <div>
        <p-select
          [options]="approverOptions"
          [(ngModel)]="field.add_as_approver"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          />
      </div>
    </div>
  `
})
export class FieldEmployees implements OnInit {
  Yii = Yii;
  @Input() field: any;

  public positions: string[] = [];

  public approverOptions = [
    {
      value: '',
      label: Yii.t('app', 'No')
    },
    {
      value: '1',
      label: Yii.t('app', 'Signature required')
    },
    {
      value: '2',
      label: Yii.t('app', 'Signature is not required')
    }
  ]

  constructor() {
  }

  ngOnInit(): void {
    if (this.field.positions_filter && this.field.positions_filter.length > 0) {
      this.positions = this.field.positions_filter.split(",");
    }
  }

  addTagFn(name: string) {
    return name;
  }
}
